// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  /* padding: 1rem; */
  margin-top: 2rem;
  display: flex;
  align-items: center;
}

.filter-heading {
  display: flex;
  align-items: center;
}

.book-filters {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.browse-header {
  font-family: "Roboto";
  color: #b40000;
  font-weight: 700;
  margin: 0;
  margin-left: 0.5rem;
}

.subheading {
  display: flex;
  align-items: center;
  margin: 0;
  margin-top: 2rem;
  padding-bottom: 10px;
  color: #12394d;
}

.options {
  padding: 3rem;
  padding-top: 0;
  padding-bottom: 1rem;
  margin-left: 8px;
  display: flex;
  align-items: center;
}

.checkbox-label-browse {
  margin-left: 8px;
  font-weight: 600;
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.more-span {
  font-weight: bold;
  color: #b40000;
  cursor: pointer;
  display: flex;
  justify-content: end;
}

.line {
  margin-left: 0px;
  margin-top: 12px;
  height: 0px;
  max-width: 75px;
  background-color: #d9d9d9;
  border: 2px solid #cccccc;
}

.date-input {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.from-to {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Collection Modal Styles */

.collection-modal-background {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.collection-modal {
  width: 450px;
  max-height: 70vh;
  overflow-y: auto;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f0f0f0;
}


.new-heading {
  border-right: 2px solid #bdbdbd;
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  margin-top: 2rem;
  padding-bottom: 10px;
  color: #12394d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (max-width: 500px) {
  .new-heading {
    border-right: none;
    border-bottom: 2px solid #bdbdbd;
    padding-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/browse.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;;AAGA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;EACtB;AACF","sourcesContent":[".heading {\n  /* padding: 1rem; */\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n}\n\n.filter-heading {\n  display: flex;\n  align-items: center;\n}\n\n.book-filters {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.browse-header {\n  font-family: \"Roboto\";\n  color: #b40000;\n  font-weight: 700;\n  margin: 0;\n  margin-left: 0.5rem;\n}\n\n.subheading {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  margin-top: 2rem;\n  padding-bottom: 10px;\n  color: #12394d;\n}\n\n.options {\n  padding: 3rem;\n  padding-top: 0;\n  padding-bottom: 1rem;\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-label-browse {\n  margin-left: 8px;\n  font-weight: 600;\n  max-width: 380px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.more-span {\n  font-weight: bold;\n  color: #b40000;\n  cursor: pointer;\n  display: flex;\n  justify-content: end;\n}\n\n.line {\n  margin-left: 0px;\n  margin-top: 12px;\n  height: 0px;\n  max-width: 75px;\n  background-color: #d9d9d9;\n  border: 2px solid #cccccc;\n}\n\n.date-input {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.from-to {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Collection Modal Styles */\n\n.collection-modal-background {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.collection-modal {\n  width: 450px;\n  max-height: 70vh;\n  overflow-y: auto;\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: #f0f0f0;\n}\n\n\n.new-heading {\n  border-right: 2px solid #bdbdbd;\n  font-size: 1.3em;\n  font-weight: 500;\n  margin: 0;\n  margin-top: 2rem;\n  padding-bottom: 10px;\n  color: #12394d;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 500px) {\n  .new-heading {\n    border-right: none;\n    border-bottom: 2px solid #bdbdbd;\n    padding-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
